import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, FormattedHTMLMessage, FormattedDate, injectIntl, intlShape } from 'react-intl'
import { toInteger, findIndex, has, find, isNil, each, filter, keyBy, unionBy, cloneDeep } from 'lodash'
import moment from 'moment'

import { callApi } from '../services/fetchService'
import { decodePatient } from '../services/encodingService'
import { getSelectOptions } from '../services/selectService'
import { openPatientRecord, openConsultation } from '../actions'

import bloodTestView from '../utils/bloodTestView.json'

import FaIcon from '../components/FaIcon'
import { Spin, Tabs, Table, Form, Card, Button, Input, DatePicker, Select, Tooltip, Modal, Affix, message } from 'antd'
const FormItem = Form.Item
const { TabPane } = Tabs
const InputGroup = Input.Group
const { Column } = Table
const { confirm } = Modal



const unicodeExponents = {
    1: '\u00B9',
    2: '\u00B2',
    3: '\u00B3',
    4: '\u2074',
    5: '\u2075',
    6: '\u2076',
    7: '\u2077',
    8: '\u2078',
    9: '\u00B9',
}



/**
 * Blood test form
 */

class _BloodTestForm extends Component {

    static propTypes = {
        comboboxes: PropTypes.object.isRequired,
        patient: PropTypes.object.isRequired,
        consultation: PropTypes.object.isRequired,
        consultations: PropTypes.array.isRequired,
        updating: PropTypes.bool,
        onSubmit: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }

    handleSubmit = (e) => {
        const { consultation } = this.props
        e.preventDefault()
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const newConsultation = Object.assign({}, consultation, {
                    laboratory: values.laboratory,
                    samplingDate: values.samplingDate,
                    bloodTest: []
                })
                each(this.getBloodTest(), (item) => {
                    const { up, down, value } = values[item.name]
                    newConsultation.bloodTest.push(Object.assign({}, item, {
                        value: (value !== null && value !== undefined && value !== '') ? Number(value) : null,
                        up: (up !== null && up !== undefined && up !== '') ? Number(up) : null,
                        down: (down !== null && down !== undefined && down !== '') ? Number(down) : null
                    }))
                })
                this.props.onSubmit(newConsultation)
            }
        })
    }

    getBloodTest = () => {
        const { comboboxes, consultation, patient } = this.props
        // Get norms
        let norms;
        if (moment().diff(patient.birthDate, 'years') <= 14) {
            norms = comboboxes.byKey.norms.child.data
        } else {
            norms = patient.gender === 'male' ? comboboxes.byKey.norms.man.data : comboboxes.byKey.norms.woman.data
        }
        // Previous blood test
        if (consultation.bloodTest.length) {
            return unionBy(consultation.bloodTest, norms, 'name')
        }
        // Norms
        return norms
    }

    render() {
        const { intl, consultation, consultations } = this.props
        const { getFieldDecorator } = this.props.form

        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            style: { marginBottom: '10px' }
        }

        let previousBloodTest = null
        for (let item of consultations) {
            if (item.id === consultation.id) {
                break
            }
            if (item.bloodTest && item.bloodTest.length) {
                previousBloodTest = item.bloodTest
            }
        }

        return (
            <Form onSubmit={this.handleSubmit}>
                <Card title={<span><FaIcon icon="notes-medical" /> <FormattedMessage id="patient.bloodTests.general" /></span>}>
                    {!!consultation.labResult ?
                        <FormItem label={<FormattedMessage id="patient.bloodTests.labResult" />} {...formItemLayout}>
                            {getFieldDecorator('labResult', {
                                initialValue: consultation.labResult
                            })(<Input disabled />)}
                        </FormItem>
                        : null}
                    <FormItem label={<FormattedMessage id="patient.bloodTests.laboratory" />} {...formItemLayout}>
                        {getFieldDecorator('laboratory', {
                            initialValue: consultation.laboratory,
                            rules: [{ required: true, message: intl.formatMessage({ id: 'patient.bloodTests.laboratoryRequired' }) }]
                        })(<Select showSearch optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getSelectOptions('laboratory', consultation.laboratory)}
                        </Select>)}
                    </FormItem>
                    <FormItem label={<FormattedMessage id="patient.bloodTests.samplingDate" />} {...formItemLayout}>
                        {getFieldDecorator('samplingDate', {
                            initialValue: consultation.samplingDate ? moment(consultation.samplingDate) : null,
                            rules: [{ required: true, message: intl.formatMessage({ id: 'patient.bloodTests.samplingDateRequired' }) }]
                        })(<DatePicker format="L" placeholder="" style={{ width: '100%' }} />)}
                    </FormItem>
                </Card>
                <Card title={<span><FaIcon icon="file-medical" /> <FormattedMessage id="patient.bloodTests.results" /></span>}>
                    {
                        this.getBloodTest().map((item) => {
                            return (
                                <FormItem label={
                                    item.name === "tsh" || item.name === "calcium" || item.name === "potassium"
                                        ? <span><FormattedMessage id={"bloodTest." + item.name} /> <Tooltip title="Respectez les normes EASE"><FaIcon icon="exclamation-triangle" color="orange" /></Tooltip></span>
                                        : <FormattedMessage id={"bloodTest." + item.name} />
                                } {...formItemLayout} key={item.name} className="norms-form">
                                    <InputGroup compact>
                                        {
                                            previousBloodTest
                                                ? <FormItem style={{ marginBottom: 0 }}>
                                                    <Input addonBefore={<FaIcon icon="history" />} style={{ width: 120 }} value={(find(previousBloodTest, { name: item.name }) || {}).value} disabled />
                                                </FormItem>
                                                : null
                                        }
                                        <FormItem style={{ marginBottom: 0 }}>{getFieldDecorator(item.name + '.value', {
                                            initialValue: item.value,
                                            rules: [{ transform: (value) => value ? Number(value) : null, min: 0, type: 'number', message: ' ' }]
                                        })(<Input addonBefore="=" style={{ width: 120 }} />)}</FormItem>
                                        <FormItem style={{ marginBottom: 0 }}>{getFieldDecorator(item.name + '.down', {
                                            initialValue: item.down,
                                            rules: [{ transform: (value) => value ? Number(value) : null, min: 0, type: 'number', message: ' ' }]
                                        })(<Input addonBefore={<FaIcon icon="arrow-down" color="blue" />} style={{ width: 120 }} />)}</FormItem>
                                        <FormItem style={{ marginBottom: 0 }}>{getFieldDecorator(item.name + '.up', {
                                            initialValue: item.up,
                                            rules: [{ transform: (value) => value ? Number(value) : null, min: 0, type: 'number', message: ' ' }]
                                        })(<Input addonBefore={<FaIcon icon="arrow-up" color="red" />} addonAfter={<div style={{ width: 70 }}>{item.unit}</div>} style={{ width: 200 }} />)}</FormItem>
                                        {item.labUnit ? <div style={{ lineHeight: '40px', marginLeft: 15 }}><FaIcon icon="exclamation-triangle" color="orange" /> Labo : {item.labUnit}</div> : null}
                                    </InputGroup>
                                </FormItem>
                            )
                        })
                    }
                </Card>
                <Affix offsetBottom={10}>
                    <div style={{ textAlign: 'right' }}>
                        <Button type="primary" loading={this.props.updating} htmlType="submit"><FormattedMessage id="misc.save" /></Button>
                    </div>
                </Affix>
            </Form>
        )
    }

}

const _mapStateToProps = (state, ownProps) => ({
    comboboxes: state.comboboxes,
    patient: state.patient
})

const BloodTestForm = injectIntl(Form.create()(connect(_mapStateToProps)(_BloodTestForm)), { withRef: true })



/**
 * Summary inside the view
 */

class _BloodTestsSummary extends Component {

    static propTypes = {
        consultations: PropTypes.array.isRequired,
        intl: intlShape.isRequired
    }

    getIndicators = (item, specificNorms) => {
        // Difference indicator
        let diff
        if (item.value < item.previous) {
            diff = <FaIcon icon="chevron-down" style={{ marginRight: 10 }} />
        } else if (item.value > item.previous) {
            diff = <FaIcon icon="chevron-up" style={{ marginRight: 10 }} />
        }
        // Calculate norm margin
        let margin = item.previous === undefined || item.previous === null || diff ? 10 : 32
        // Norm indicator
        let norm
        if (item.value < item.down) {
            norm = <FaIcon icon={["fas", "circle"]} color="blue" style={{ marginRight: margin }} />
        } else if (item.value > item.up) {
            norm = <FaIcon icon={["fas", "circle"]} color="red" style={{ marginRight: margin }} />
        } else {
            norm = <FaIcon icon="circle" style={{ marginRight: margin }} />
        }
        // Tooltip or not
        if (specificNorms) {
            return <Tooltip title={(item.down + ' - ' + item.up + ' ' + item.unit)}>{norm}{diff}</Tooltip>
        } else {
            return <span>{norm}{diff}</span>
        }
    }

    computeData = (consultations) => {
        // Structure to return
        const data = cloneDeep(bloodTestView)
        // Get items into object for better search.
        const indexedItems = keyBy(data, 'name')
        // Go through all biologies to add the elements to the items (data structure to return)
        each(consultations, consultation => {
            each(consultation.bloodTest, element => {
                const item = indexedItems[element.name]
                // If item must be shown (view)
                if (!item) return
                // If element has not a null value
                if (element.value === null) return
                // Add data
                const toAdd = cloneDeep(element)
                if (!isNil(item._lastConsultId)) {
                    toAdd.previous = item[item._lastConsultId].value
                    item[consultation.id] = toAdd
                    if ((item.up && item.up !== toAdd.up) || (item.down && item.down !== toAdd.down)) {
                        delete item.up
                        delete item.down
                    }
                } else {
                    item[consultation.id] = toAdd
                    item.up = toAdd.up
                    item.down = toAdd.down
                    item.unit = toAdd.unit
                }
                item._lastConsultId = consultation.id
            })
        })
        // Return
        return data
    }

    hasMinOneKey = (object, keys) => {
        for (let key of keys) {
            if (has(object, key)) return true
        }
        return false
    }

    isNormsSpecific = item => isNil(item.up)

    render() {
        const { consultations } = this.props

        const data = this.computeData(consultations)
        const consultationIds = filter(consultations, item => !!item.bloodTest.length).map(consultation => consultation.id)

        return (
            <Table dataSource={data} rowKey="name" size="middle" pagination={false}>
                <Column title={<FormattedMessage id="patient.bloodTests.element" />} key="element" render={(record) => (<FormattedMessage id={"bloodTest." + record.name} />)} />
                {
                    filter(consultations, (item) => !!item.bloodTest.length).map((consultation) => <Column title={<FormattedDate value={consultation.date} />} key={"" + consultation.id} render={
                        (record) => record[consultation.id]
                            ? <span>{this.getIndicators(record[consultation.id], this.isNormsSpecific(record))}{record[consultation.id].value}</span>
                            : null
                    } />)
                }
                <Column title={<FormattedMessage id="patient.bloodTests.norm" />} key="norm" render={
                    (record) => this.isNormsSpecific(record)
                        ? (this.hasMinOneKey(record, consultationIds) ? "Variables" : "")
                        : (record.down + ' - ' + record.up + ' ' + record.unit)
                } />
            </Table>
        )
    }

}

const BloodTestsSummary = injectIntl(_BloodTestsSummary)



class _LabResultImportModal extends Component {

    state = {
        visible: false,
        labResult: null,
    }

    showModal = () => {
        this.setState({ visible: true })
    }

    hideModal = () => {
        this.setState({ visible: false, labResult: null })
    }

    handlelabResultChange = (event) => {
        this.setState({ labResult: event.target.value })
    }

    importLabResult = () => {
        const { intl } = this.props
        callApi({
            endpoint: 'lab-results/' + this.state.labResult
        }).then((data) => {
            this.props.importLabResult(data)
            this.setState({ visible: false, labResult: null })
        }).catch((data) => {
            if (data.status === 404) {
                message.error(intl.formatMessage({ id: 'patient.bloodTests.labResultNotFound' }))
            } else {
                message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            }
        })

    }

    render() {
        const { visible, labResult } = this.state
        return (
            <Modal title={<FormattedMessage id="patient.bloodTests.importModalTitle" />} visible={visible} onOk={this.importLabResult} onCancel={this.hideModal}>
                <FormattedMessage id="patient.bloodTests.labResult" /> :
                <Input type="number" value={labResult} onChange={this.handlelabResultChange} style={{ marginTop: 5 }} />
            </Modal>
        )
    }

}

const LabResultImportModal = injectIntl(_LabResultImportModal, { withRef: true })




/**
 * BloodTests view
 */

class PatientBloodTests extends Component {

    static propTypes = {
        openPatientRecord: PropTypes.func.isRequired,
        openConsultation: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        consultation: PropTypes.object,
        intl: intlShape.isRequired,
        session: PropTypes.object.isRequired
    }

    state = {
        patientId: null,
        patient: {},
        consultations: null,
        loading: false,
        updating: false,
        activeTab: null
    }

    fetch = () => {
        const { intl, openPatientRecord } = this.props
        this.setState({ loading: true })
        callApi([{
            endpoint: 'patients/' + this.state.patientId
        }, {
            endpoint: 'patients/' + this.state.patientId + '/consultations'
        }]).then((data) => {
            decodePatient(data[0]).then((decoded) => {
                data[0] = decoded
                openPatientRecord(data[0])
                this.setState({
                    patient: data[0],
                    consultations: data[1],
                    loading: false
                })
            })
        }).catch((data) => {
            message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            this.setState({ loading: false })
        })
    }

    componentWillReceiveProps(nextProps) {
        let id = toInteger(nextProps.match.params.id)
        if (this.state.patientId !== id) {
            this.setState({ patientId: id }, () => {
                this.fetch()
            })
        }
    }

    componentWillMount() {
        let id = toInteger(this.props.match.params.id)
        this.setState({ patientId: id })
    }

    componentDidMount() {
        this.fetch()
    }

    saveConsultation = (consultation) => {
        const { intl } = this.props
        const { consultations } = this.state
        this.setState({
            updating: true
        })
        callApi({
            endpoint: 'consultations/' + consultation.id,
            body: consultation,
            method: 'POST'
        }).then((data) => {
            consultations[findIndex(consultations, { id: data.id })] = data
            this.setState({
                consultations: consultations,
                updating: false
            })
            message.success(this.props.intl.formatMessage({ id: "misc.updateSuccess" }))
        }).catch((err) => {
            consultations[findIndex(consultations, { id: consultation.id })] = consultation
            message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            this.setState({ updating: false })
        })
    }

    addConsultation = () => {
        const { intl, openConsultation } = this.props
        const { consultations } = this.state
        if (this.canAddConsultation()) {
            callApi({
                endpoint: 'consultations',
                body: {
                    patient: this.state.patientId,
                    date: Date.now()
                },
                method: 'PUT'
            }).then((data) => {
                consultations.push(data)
                this.setState({
                    consultations: consultations,
                    updating: false,
                    activeTab: "" + data.id
                })
                openConsultation(data)
                message.success(this.props.intl.formatMessage({ id: "misc.updateSuccess" }))
            }).catch((err) => {
                message.error(intl.formatMessage({ id: 'misc.unknownError' }))
                this.setState({ updating: false })
            })

        }
    }

    canAddConsultation = () => {
        const { consultations } = this.state
        if (consultations.length) {
            const lastDate = consultations[consultations.length - 1].date
            return !moment(lastDate).isSame(moment(), 'day')
        }
        return true
    }

    onTabsChange = (activeTab) => {
        this.setState({ activeTab: "" + activeTab });
    }

    showModal = () => {
        this.modal.showModal();
    }

    importLabResult = (labResult) => {
        const { consultations } = this.state
        const currentActiveTab = this.state.activeTab;
        const { comboboxes, patient } = this.props
        const currentConsultation = this.props.consultation;
        // Get real active tab (first null)
        const activeTab = currentActiveTab || (currentConsultation ? "" + currentConsultation.id : (consultations.length ? "" + consultations[consultations.length - 1].id : null))
        // Get consultation of the active tab
        const consultation = find(consultations, { id: Number(activeTab) })
        // Data
        consultation.labResult = labResult.id
        consultation.laboratory = labResult.laboratory
        consultation.samplingDate = labResult.samplingDate
        // Blood test
        let norms;
        if (moment().diff(patient.birthDate, 'years') <= 14) {
            norms = comboboxes.byKey.norms.child.data
        } else {
            norms = patient.gender === 'male' ? comboboxes.byKey.norms.man.data : comboboxes.byKey.norms.woman.data
        }
        norms = cloneDeep(norms);
        const bt = keyBy(labResult.data, 'name')
        each(norms, (item) => {
            const btItem = bt[item.name]
            if (btItem) {
                item.value = btItem.value
                btItem.unit = btItem.unit.replace(/\^([0-9])/g, (match, $1) => unicodeExponents[$1]);
                if (btItem.unit !== item.unit) {
                    item.labUnit = btItem.unit
                }
                // Set default up/down values
                switch (item.name) {
                    case 'cpk': item.down = btItem.down === null ? 25 : btItem.down; break;
                    case 'ldh': item.down = btItem.down === null ? 125 : btItem.down; break;
                    case 'intestinalPal': item.down = btItem.down === null ? 0.2 : btItem.down; break;
                    case 'eosinophils': item.down = (btItem.down === null || btItem.down === 0) ? 0.2 : btItem.down; break;
                    case 'basophils': item.down = (btItem.down === null || btItem.down === 0) ? 0.2 : btItem.down; break;
                    case 'ca199': item.down = btItem.down === null ? 1 : btItem.down; break;
                    default: if (btItem.down !== null) item.down = btItem.down;
                }
                if (btItem.up !== null) item.up = btItem.up
            }
        })
        consultation.bloodTest = norms;
        // Done
        this.setState({ consultations: consultations })
    }

    refreshLabResult = (labResultId) => {
        const { intl } = this.props
        const importLabResult = this.importLabResult
        const bloodTestForm = this.bloodTestForm
        confirm({
            title: intl.formatMessage({ id: 'misc.confirm' }),
            content: intl.formatMessage({ id: 'patient.bloodTests.confirmRefreshFromLab' }),
            onOk() {
                callApi({
                    endpoint: 'lab-results/' + labResultId
                }).then((data) => {
                    bloodTestForm.resetFields()
                    importLabResult(data)
                }).catch(() => {
                    message.error(intl.formatMessage({ id: 'misc.unknownError' }))
                })
            }
        })
    }

    render() {
        const { patient, loading, consultations, activeTab } = this.state
        const { consultation } = this.props
        const { user } = this.props.session

        if (consultations === null || loading) {
            return (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <Spin size="large" />
                </div>
            )
        }

        const currentConsultationId = consultation ? consultation.id : null
        const newActiveTab = activeTab || (consultation ? "" + consultation.id : (consultations.length ? "" + consultations[consultations.length - 1].id : null))
        const visibleConsultation = find(consultations, { id: Number(newActiveTab) })

        return (
            <div>
                <h1><FaIcon icon="user" fixedWidth /><FormattedHTMLMessage id="patient.bloodTests.title" values={patient} /></h1>
                <div className="action-bar">
                    {visibleConsultation
                        ? visibleConsultation.labResult
                            ? <Button onClick={() => this.refreshLabResult(visibleConsultation.labResult)}><FaIcon icon="cloud-download" /> <FormattedMessage id="patient.bloodTests.refreshFromLab" /></Button>
                            : <Button onClick={this.showModal}><FaIcon icon="cloud-download" /> <FormattedMessage id="patient.bloodTests.importFromLab" /></Button>
                        : null
                    }
                    {this.canAddConsultation() && <Button onClick={this.addConsultation} disabled={!user.canAddConsultations}><FaIcon icon="plus" /> <FormattedMessage id="patient.misc.addConsultation" /></Button>}
                </div>
                {
                    !consultations.length ? (
                        <div className="message" style={{ marginTop: "45px" }}>
                            <FaIcon icon="exclamation-circle" size="8x" />
                            <br /><br />
                            <span style={{ fontSize: "35px" }}><FormattedMessage id="patient.misc.noConsultations" /></span>
                            <br /><br />
                            <FormattedMessage id="patient.misc.noConsultations.description" />
                        </div>
                    ) : (
                        <div>
                            <Tabs onChange={this.onTabsChange} activeKey={newActiveTab}>
                                <TabPane tab={<strong><FaIcon icon="clipboard-list" fixedWidth /> <FormattedMessage id="patient.bloodTests.all" /></strong>} key="all">
                                    <BloodTestsSummary consultations={consultations} />
                                </TabPane>
                                {
                                    consultations.map((consultation, index) => (
                                        <TabPane tab={consultation.id === currentConsultationId
                                            ? <strong><FaIcon icon="angle-double-right" size="lg" fixedWidth /> <FormattedDate value={consultation.date} /></strong>
                                            : <FormattedDate value={consultation.date} />
                                        } key={"" + consultation.id}>
                                            <BloodTestForm ref={(c) => this.bloodTestForm = c ? c.getWrappedInstance() : null} consultation={consultation} consultations={consultations} onSubmit={this.saveConsultation} />
                                        </TabPane>
                                    ))
                                }
                            </Tabs>
                            <LabResultImportModal ref={(c) => this.modal = c ? c.getWrappedInstance() : null} importLabResult={this.importLabResult} />
                        </div>
                    )
                }
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    consultation: state.consultation,
    comboboxes: state.comboboxes,
    patient: state.patient,
    session: state.session
})

export default injectIntl(withRouter(connect(mapStateToProps, {
    openPatientRecord,
    openConsultation
})(PatientBloodTests)))


// WEBPACK FOOTER //
// ./src/views/PatientBloodTests.js